var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosebuttone5C00B54(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1830.25 -25.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1888.25 25.75) rotate(90)",
    fill: "#fff",
    stroke: "#f15b44",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.645,9.529,25.616,7.5l-8.044,8.044L9.529,7.5,7.5,9.529l8.044,8.044L7.5,25.616l2.029,2.029L17.573,19.6l8.044,8.044,2.029-2.029L19.6,17.573Z",
    transform: "translate(1841.927 38.927)",
    fill: "#f15b44"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebuttone5C00B54);
export default __webpack_public_path__ + "static/media/closebutton.e5c00b54.e5c00b54c6a9df7b0ce88f06fc5269c4.svg";
export { ForwardRef as ReactComponent };